export default __webpack_public_path__ + "static/media/ISKO CLASS 4 SYLLABUS.dca3ab31.pdf";